import React from 'react';
import "./footer.css"
import whiteLogo from '../../assets/pdi-white-logo2.png';
import { FaInstagram, FaInstagramSquare, FaLinkedin, FaLinkedinIn } from 'react-icons/fa';
import { GrInstagram } from 'react-icons/gr';
import { useLanguage } from '../../context/LanguageContext';

const Footer = () => {
    const { t, changeLanguage } = useLanguage();
    return (
        <footer className="footer-container text-white ">
            <div className='footer-top-container md:grid grid-cols-4 gap-8'>
                <div className='flex justify-center'>
                    <img src={whiteLogo} className='w-7/12 mb-4' alt="" />
                    {/* <p className='font-medium'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet exercitationem beatae at? Expedita voluptas, illo blanditiis eveniet eaque aut libero necessitatibus eos? </p> */}
                </div>
                <div>
                    <h3 className='footer-title'>{t("products")}</h3>
                    <div className='flex flex-col leading-8'>
                        <a href="/products" className="footer-top-link">PDI</a>
                        {/* <a href="/products" className="footer-top-link">PDI Social</a> */}
                        {/* <a href="#" className="footer-top-link">- Email</a>
                        <a href="#" className="footer-top-link">- Metin Düzenleme</a> */}
                    </div>
                </div>
                <div>
                    <h3 className='footer-title'>{t("management")}</h3>
                    <div className='flex flex-col leading-8'>
                        <a href="/about" className="footer-top-link">{t("about")}</a>
                        <a href="/contact" className="footer-top-link">{t("contact")}</a>
                        {/* <a href="#" className="footer-top-link">- Topluluk</a>
                        <a href="#" className="footer-top-link">- Bağlı Kuruluşlar</a> */}
                    </div>
                </div>
                <div>
                    <h3 className='footer-title'>{t("follow-us")}</h3>
                    <div className='flex flex-col leading-8'>
                        {/* <a href="https://facebook.com/profile.php?id=100085283804721" className="footer-top-link">- Facebook</a>
                        <a href="https://twitter.com/AlohaLiveApptr" className="footer-top-link">- X</a> */}
                        <a href="https://www.instagram.com/pdi_ai/" className="footer-top-link flex items-center gap-2"><GrInstagram />Instagram</a>
                        <a href="https://www.linkedin.com/company/verius-teknoloji" className="footer-top-link flex items-center gap-2"><FaLinkedinIn />LinkedIn</a>
                    </div>
                </div>

            </div>
            <div className='footer-bottom-container flex items-center justify-between '>
                <div>© 2025 <a className='footer-bottom-link' href="https://www.alohadijital.com/">Aloha Dijital.</a>  {t("all-rights")}
                </div>
                {/* <div><a href="https://www.alohadijital.com/storage/documents/KVKKPolitikas%C4%B1.pdf" className='footer-bottom-link'>Aloha Dijital KVKK</a></div> */}
            </div>
        </footer>
    );
};

export default Footer;
